<div class="split-view">
  <div class="left">
    <ng-content select="[left]"></ng-content>
  </div>
  <div class="divider"></div>
  <div class="right">
    <ng-content select="[right]"></ng-content>
  </div>
</div>
